import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {RawAuthClient} from '../types'

export interface ListAuthClientsResponse {
  Clients: RawAuthClient[]
}

export interface ListAuthClients<R> {
  (http: HttpInstance, accessToken: string): Promise<AxiosResponse<R>>
}

export const listAuthClients: ListAuthClients<ListAuthClientsResponse> = (
  http,
  accessToken,
) => {
  // Create request config with Authorization header
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }

  return http.get<ListAuthClientsResponse>(`/v1/auth/clients`, config)
}
